import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./common.css";
import "./style.css";

export default function TopNavPublic() {
  return (
    <div className="TopNav">
      <nav className="sb-topnav navbar navbar-expand navbar-light bg-light">
        <a className="navbar-brand ps-3 d-flex align-items-center" href="/">
          <img
            src="../2logoforwebsite.png"
            id="apitcologo"
            alt="APITCO Logo"
          />
        </a>
      </nav>
    </div>
  );
}
